import React, { useEffect, useState } from "react";

const Filter = (props) => {
  const [locationModal, setModal] = useState(false);
  const showModal = () => {
    setModal(true);
  };
  const hideModal = () => {
    setModal(false);
  };
  //  for primary skill
  const [skillModal, setSkillModal] = useState(false);
  const showSkillModal = () => {
    setSkillModal(true);
  };
  const hideSkillModal = () => {
    setSkillModal(false);
  };
  // for secondry skill
  const [primarySkillModal, setPrimarySkillModal] = useState(false);
  const showPrimarySkillModal = () => {
    setPrimarySkillModal(true);
  };
  const hidePrimarySkillModal = () => {
    setPrimarySkillModal(false);
  };
  // domain
  const [domainModal, setDomainModal] = useState(false);
  const showDomainModal = () => {
    setDomainModal(true);
  };
  const hideDomainModal = () => {
    setDomainModal(false);
  };
  // education
  const [educationModal, setEducationModal] = useState(false);
  const showEducationModal = () => {
    setEducationModal(true);
  };
  const hideEducationModal = () => {
    setEducationModal(false);
  };

  // certificate
  const [certificateModal, setCertificateModal] = useState(false);
  const showCertificateModal = () => {
    setCertificateModal(true);
  };
  const hideCertificateModal = () => {
    setCertificateModal(false);
  };

  const filterToggleShow = () => {
    document.getElementById("sidebaricon").style.pointerEvents = "auto";
    document.getElementsByClassName(
      "filtertogglebutton"
    )[0].style.pointerEvents = "auto";
    const hide = document.getElementsByClassName("hide")[0].style.display;
    if (hide === "none") {
      const sidebar = document.getElementsByClassName("sidebar")[0];
      sidebar.style.cssText = "width:95px; min-width:100px !important;padding-left:0px";
      const companylogo = document.getElementsByClassName("companylogo")[0];
      companylogo.style.cssText =
        "position:relative;width:129px;height:auto;transform:scale(0.8); right:1rem ;top:0.6rem";
      const container = document.getElementsByClassName("stick")[0];
      container.style.cssText =
        "margin-left:100px;border-radius:38px 0px 0px 0px";
      // document.getElementsByClassName('humbergerIcon')[0].style.cssText = "transform:translateX(12%) scale(0.8) ";
      document.getElementsByClassName('humbergerIcon')[0].style.cssText = "transform:translateX(-663%) scale(0.8);cursor:pointer ";
      document.getElementById('replacetitleimg').style.cssText = "margin-left:-11rem"

    } else {
    }
  };
  const [location, setLocation] = useState([]);
  const [outsideLocation, setOutsideLocation] = useState([]);
  const [primary, setPrimary] = useState([]);
  const [secondary, setSecondary] = useState([]);
  const [domain, setDomain] = useState([]);
  const [education, setEducation] = useState([]);
  const [certificate, setCertificate] = useState([]);
  const [checked, setChecked] = useState([]);
  //list of location
  useEffect(() => {
    try {
      if (props.location.length !== 0) {
        setLocation(props.location);
      }
    } catch { }
  }, [props.location]);
  //list of outside location
  useEffect(() => {
    try {
      if (props.outsideLocation.length !== 0) {
        setOutsideLocation(props.outsideLocation);
      }
    } catch { }
  }, [props.outsideLocation]);
  //list of skill
  useEffect(() => {
    try {
      if (props.primary.length !== 0) {
        setPrimary(props.primary);
      }
    } catch { }
  }, [props.primary]);
  //list of secondary skill
  useEffect(() => {
    try {
      if (props.secondary.length !== 0) {
        setSecondary(props.secondary);
      }
    } catch { }
  }, [props.secondary]);
  //list of domain
  useEffect(() => {
    try {
      if (props.domain.length !== 0) {
        setDomain(props.domain);
      }
    } catch { }
  }, [props.domain]);
  //list of education
  useEffect(() => {
    try {
      if (props.education.length !== 0) {
        setEducation(props.education);
      }
    } catch { }
  }, [props.education]);
  //list of certificate
  useEffect(() => {
    try {
      if (props.certificate.length !== 0) {
        setCertificate(props.certificate);
      }
    } catch { }
  }, [props.certificate]);
  //list of all selected location
  useEffect(() => {
    try {
      setChecked(props.checked);
    } catch { }
  }, [props.checked]);

  //list of rateCards
  const workAuthorizationData = [
    { workAuth: "US_CITIZEN" },
    { workAuth: "GREEN_CARD" },
    { workAuth: "GC_EAD" },
    { workAuth: "H1B" },
    { workAuth: "H4_EAD" },
    { workAuth: "OPT" },
    { workAuth: "OPT-STEM" },
    { workAuth: "CPT" },
    { workAuth: "TN_VISA" },
    { workAuth: "TN_EAD" },
    { workAuth: "E3" },
    { workAuth: "APPROVED_I_140" },
  ];
  const employmentData = [
    { type: "FULL_TIME" },
    { type: "C2C" },
    { type: "C2H" },
    { type: "W2" },
    { type: "W2_HOURLY" },
    { type: "1099" },
  ];
  const securityCategory = [
    { name: "SCI" },
    { name: "SAPS" },
    { name: "RD" },
    { name: "FRD" },
    { name: "NSI" },
  ];

  const information = props.locationInformation;
  const handleInformation = props.handleInformation;
  return (
    <div
      className={"modal  right"}
      id={"modalfilter"}
      role={"dialog"}
      data-backdrop="false"
      aria-labelledby="myModalLabel2"
    >
      <div className={"modal-dialog modal-lg "}>
        <div className={"modal-content pr-2 background-colored-Soft-lavender border-radius-05rem"} >
          <div className={"scrollmodal"}>
            <div className="row">
              <div className="col-md-1">
                <button
                  className="clearbtn"
                  data-dismiss={"modal"}
                  onClick={filterToggleShow}
                >
                  &times;
                </button>
              </div>
              <div className={"col-md-1"}>
                <label className="ml-2 mt-2 textColor">FILTERS</label>
              </div>
              <div className={"col-md"}>
                <label
                  className={"float-right pr-2 headingfont mt-2 colored-Deep-violet font-size-08 cursor-pointer"}

                  onClick={props.handleClearAll}
                >
                  CLEAR ALL
                </label>
              </div>
            </div>
          </div>
          <div
            className={"modal-body  border-radius-20px"}

          >
            <form>
              <div className="row mx-1">
                <input
                  type="radio"
                  name="pay"
                  id="rad1"
                  className="modalradio"
                  value={"HOURLY"}
                  onClick={props.handleRateFilter}
                />
                <label htmlFor="rad1" className="skill pl-4">
                  Hourly
                </label>
                <br />
              </div>
              <div className="row mx-1">
                <input
                  type="radio"
                  name="pay"
                  id="rad1"
                  className="modalradio"
                  value={"YEARLY"}
                  onClick={props.handleRateFilter}
                />
                <label htmlFor="rad1" className="skill pl-4">
                  Yearly
                </label>
                <br />
              </div>
              {/* <hr className={"divider"} /> */}
              {/* for location */}
              <div className={"dropdownfilter"}>
                <h4 className="labelDesign">Location</h4>
                {outsideLocation.slice(0, 5).map((location, index) => (
                  <li key={index} className="filterDirectorylisttitle">
                    {" "}
                    <input
                      type="checkbox"
                      id={location.city}
                      className="modalcheckbox ml-2"
                      value={location.city}
                      onClick={props.handleLocationFilter}
                      checked={checked.includes(location.city) ? true : false}
                    />
                    <label
                      htmlFor={location.city}
                      className="pl-4 modaltext mt-1"
                    >
                      {location.city}
                    </label>
                  </li>
                ))}
                <button
                  type="button"
                  className="btnshow pl-5 colored-Royal-purple font-weight-500 font-size-08"
                  onClick={showModal}

                >
                  Show more
                </button>

                <div
                  className={`modal popupsecondbox fade ${locationModal ? "show" : ""
                    }`}
                  aria-labelledby="myLargeModalLabel"
                  style={{
                    display: `${locationModal ? "block" : "none"}`,
                  }}
                  tabIndex="-1"
                  role="dialog"
                  id={"modalLocation"}
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="input-group">
                          <div className="form-outline">
                            <input
                              type="search"
                              id="form1"
                              className="form-control"
                              placeholder="Search Location"
                              value={information.locationData}
                              name={"locationData"}
                              onChange={handleInformation}
                            />
                          </div>
                        </div>
                        <button
                          type="button"
                          className="close"
                          onClick={hideModal}
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <ul className={"filterdirectory"}>
                          {location.map((location, index) => (
                            <li
                              key={index}
                              className="filterDirectorylisttitle"
                            >
                              {" "}
                              <input
                                type="checkbox"
                                id={location.city}
                                name={""}
                                className="modalcheckbox ml-2 locationcheck"
                                value={location.city}
                                onClick={props.handleLocationFilter}
                                checked={
                                  checked.includes(location.city) ? true : false
                                }
                              />
                              <label
                                htmlFor={location.city}
                                className="pl-4 modaltext mt-1"
                              >
                                {location.city}
                              </label>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* {primary.length !== 0 && <hr className={"divider"} />} */}
              {/* lolcation end here */}
              {/* for primary skill */}
              <div className={"dropdownfilter"}>
                {primary.length !== 0 && <h4 className="labelDesign">Primary Skill</h4>}
                {primary.slice(0, 5).map((primary, index) => (
                  <div key={index}>
                    {primary.ClientPrimarySkill.length !== 0 && (
                      <li className="filterDirectorylisttitle">
                        {" "}
                        <input
                          type="checkbox"
                          id={primary.ClientPrimarySkill}
                          className="modalcheckbox ml-2"
                          value={primary.ClientPrimarySkill}
                          onClick={props.handlePrimarySkillFilter}
                        />
                        <label
                          htmlFor={primary.ClientPrimarySkill}
                          className="pl-4 modaltext mt-1"
                        >
                          {primary.ClientPrimarySkill}
                        </label>
                      </li>
                    )}
                  </div>
                ))}
                {primary.length > 5 ? (
                  <button
                    type="button"
                    className="btnshow pl-5 colored-Royal-purple font-weight-500 font-size-08"
                    onClick={showSkillModal}

                  >
                    Show more
                  </button>
                ) : (
                  ""
                )}
                <div
                  className={`modal fade popupsecondbox newmodelbox skill-example-modal-lg ${skillModal ? "show" : ""
                    }`}
                  aria-labelledby="myLargeModalLabel"
                  style={{
                    display: `${skillModal ? "block" : "none"}`,
                  }}
                  tabIndex="-1"
                  role="dialog"
                  id={"modalLocation"}
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="input-group">
                          <div className="form-outline">
                            <input
                              type="search"
                              id="form1"
                              className="form-control"
                              placeholder="Search Location"
                            />
                          </div>
                        </div>
                        <button
                          type="button"
                          className="close"
                          onClick={hideSkillModal}
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <ul className={"filterdirectory"}>
                          {primary.slice(5).map((primary, index) => (
                            <div key={index}>
                              {primary.ClientPrimarySkill.length !== 0 && (
                                <li className="filterDirectorylisttitle">
                                  {" "}
                                  <input
                                    type="checkbox"
                                    id={primary.ClientPrimarySkill}
                                    className="modalcheckbox ml-2"
                                    value={primary.ClientPrimarySkill}
                                    onClick={props.handlePrimarySkillFilter}
                                  />
                                  <label
                                    htmlFor={primary.ClientPrimarySkill}
                                    className="pl-4 modaltext mt-1"
                                  >
                                    {primary.ClientPrimarySkill}
                                  </label>
                                </li>
                              )}
                            </div>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {secondary.length !== 0 && <hr className={"divider"} />}
              {/*primary skill end */}
              {/* for secondary skill */}
              <div className={"dropdownfilter"}>
                {secondary.length !== 0 && <h4 className="labelDesign"> Secondary Skill</h4>}
                {secondary.slice(0, 5).map((secondary, index) => (
                  <div key={index}>
                    {secondary.ClientSecondarySkill.length !== 0 && (
                      <li className="filterDirectorylisttitle">
                        {" "}
                        <input
                          type="checkbox"
                          id={secondary.ClientSecondarySkill}
                          className="modalcheckbox ml-2"
                          value={secondary.ClientSecondarySkill}
                          onClick={props.handleSecondarySkillFilter}
                        />
                        <label
                          htmlFor={secondary.ClientSecondarySkill}
                          className="pl-4 modaltext mt-1"
                        >
                          {secondary.ClientSecondarySkill}
                        </label>
                      </li>
                    )}
                  </div>
                ))}
                {secondary.length > 5 ? (
                  <button
                    type="button"
                    className="btnshow pl-5 colored-Royal-purple font-weight-500 font-size-08"
                    onClick={showPrimarySkillModal}

                  >
                    Show more
                  </button>
                ) : (
                  ""
                )}
                <div
                  className={`modal fade popupsecondbox newmodelbox skill-example-modal-lg ${primarySkillModal ? "show" : ""
                    }`}
                  aria-labelledby="myLargeModalLabel"
                  style={{
                    display: `${primarySkillModal ? "block" : "none"}`,
                  }}
                  tabIndex="-1"
                  role="dialog"
                  id={"modalLocation"}
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="input-group">
                          <div className="form-outline">
                            <input
                              type="search"
                              id="form1"
                              className="form-control"
                              placeholder="Search Location"
                            />
                          </div>
                        </div>

                        <button
                          type="button"
                          className="close"
                          onClick={hidePrimarySkillModal}
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <ul className={"filterdirectory"}>
                          {secondary.slice(5).map((secondary, index) => (
                            <div key={index}>
                              {secondary.ClientSecondarySkill.length !== 0 && (
                                <li className="filterDirectorylisttitle">
                                  {" "}
                                  <input
                                    type="checkbox"
                                    id={secondary.ClientSecondarySkill}
                                    className="modalcheckbox ml-2"
                                    value={secondary.ClientSecondarySkill}
                                    onClick={props.handleSecondarySkillFilter}
                                  />
                                  <label
                                    htmlFor={secondary.ClientSecondarySkill}
                                    className="pl-4 modaltext mt-1"
                                  >
                                    {secondary.ClientSecondarySkill}
                                  </label>
                                </li>
                              )}
                            </div>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* {domain.length !== 0 && <hr className={"divider"} />} */}
              {/*secondry skill end */}
              {/* domain start */}
              <div className={"dropdownfilter"}>
                {domain.length !== 0 && <h4 className="labelDesign">Domain</h4>}
                {domain.slice(0, 5).map((domain, index) => (
                  <li key={index} className="filterDirectorylisttitle">
                    {" "}
                    <input
                      type="checkbox"
                      id={domain.domain}
                      className="modalcheckbox ml-2"
                      value={domain.domain}
                      onClick={props.handleDomainFilter}
                    />
                    <label
                      htmlFor={domain.domain}
                      className="pl-4 modaltext mt-1"
                    >
                      {domain.domain}
                    </label>
                  </li>
                ))}
                {domain.length > 5 ? (
                  <button
                    type="button"
                    className="btnshow pl-5 colored-Royal-purple font-weight-500 font-size-08"
                    onClick={showDomainModal}

                  >
                    Show more
                  </button>
                ) : (
                  ""
                )}
                <div
                  className={`modal fade popupsecondbox newmodelbox domain-example-modal-lg ${domainModal ? "show" : ""
                    }`}
                  aria-labelledby="myLargeModalLabel"
                  style={{
                    display: `${domainModal ? "block" : "none"}`,
                  }}
                  tabIndex="-1"
                  role="dialog"
                  id={"modalLocation"}
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="input-group">
                          <div className="form-outline">
                            <input
                              type="search"
                              id="form1"
                              className="form-control"
                              placeholder="Search Location"
                            />
                          </div>
                        </div>
                        <button
                          type="button"
                          className="close"
                          onClick={hideDomainModal}
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <ul className={"filterdirectory"}>
                          {domain.slice(5).map((domain, index) => (
                            <li
                              key={index}
                              className="filterDirectorylisttitle"
                            >
                              {" "}
                              <input
                                type="checkbox"
                                id={domain.domain}
                                className="modalcheckbox ml-2"
                                value={domain.domain}
                                onClick={props.handleDomainFilter}
                              />
                              <label
                                htmlFor={domain.domain}
                                className="pl-4 modaltext mt-1"
                              >
                                {domain.domain}
                              </label>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* domain end */}
              {/* <hr className={"divider"} /> */}
              {/* education */}
              <div className={"dropdownfilter"}>
                <h4 className="labelDesign">Education</h4>
                {education.slice(0, 5).map((education, index) => (
                  <div key={index}>
                    {
                      <li className="filterDirectorylisttitle">
                        <input
                          type="checkbox"
                          id={education.academicsQualification}
                          className="modalcheckbox ml-2"
                          value={education.academicsQualification}
                          onClick={props.handleEducationFilter}
                        />
                        <label
                          htmlFor={education.academicsQualification}
                          className="pl-4 modaltext mt-1"
                        >
                          {education.academicsQualification}
                        </label>
                      </li>
                    }
                  </div>
                ))}
                {education.length > 5 ? (
                  <button
                    type="button"
                    className="btnshow pl-5 colored-Royal-purple font-weight-500 font-size-08"
                    onClick={showEducationModal}

                  >
                    Show more
                  </button>
                ) : (
                  ""
                )}
                <div
                  className={`modal fade popupsecondbox newmodelbox education-example-modal-lg ${educationModal ? "show" : ""
                    }`}
                  aria-labelledby="myLargeModalLabel"
                  style={{
                    display: `${educationModal ? "block" : "none"}`,
                  }}
                  tabIndex="-1"
                  role="dialog"
                  id={"modalLocation"}
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="input-group">
                          <div className="form-outline">
                            <input
                              type="search"
                              id="form1"
                              className="form-control"
                              placeholder="Search Location"
                            />
                          </div>
                        </div>
                        <button
                          type="button"
                          className="close"
                          onClick={hideEducationModal}
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <ul className={"filterdirectory"}>
                          {education.slice(5).map((education, index) => (
                            <div key={index}>
                              <li className="filterDirectorylisttitle">
                                <input
                                  type="checkbox"
                                  id={education.academicsQualification}
                                  className="modalcheckbox ml-2"
                                  value={education.academicsQualification}
                                  onClick={props.handleEducationFilter}
                                />
                                <label
                                  htmlFor={education.academicsQualification}
                                  className="pl-4 modaltext mt-1"
                                >
                                  {education.academicsQualification}
                                </label>
                              </li>
                            </div>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* education end */}
              {/* <hr className={"divider"} /> */}
              {/* work authorization */}
              <div className={"dropdownfilter"}>
                <h4 className="labelDesign">Work Authorization</h4>
                {workAuthorizationData.map((data, index) => (
                  <li key={index} className="filterDirectorylisttitle">
                    {" "}
                    <input
                      type="checkbox"
                      id={data.workAuth}
                      className="modalcheckbox ml-2"
                      value={data.workAuth}
                      onClick={props.handleWorkAuthFilter}
                    />
                    <label
                      htmlFor={data.workAuth}
                      className="pl-4 modaltext mt-1"
                    >
                      {data.workAuth}
                    </label>
                  </li>
                ))}
              </div>
              {/* end work auth */}
              {/* <hr className={"divider"} /> */}
              {/* employe type */}
              <div className={"dropdownfilter"}>
                <h4 className="labelDesign">Employement Type</h4>
                {employmentData.map((data, index) => (
                  <li key={index} className="filterDirectorylisttitle">
                    {" "}
                    <input
                      type="checkbox"
                      id={data.type}
                      className="modalcheckbox ml-2"
                      value={data.type}
                      onClick={props.handleEmploymentFilter}
                    />
                    <label htmlFor={data.type} className="pl-4 modaltext mt-1">
                      {data.type}
                    </label>
                  </li>
                ))}
              </div>
              {/* end employee type */}
              {/* <hr className={"divider"} /> */}
              {/* us degree */}
              <div className={"dropdownfilter"}>
                <h4 className="labelDesign">US Degree</h4>
                <div className="d-flex mx-1">
                  <input
                    type="radio"
                    name="group"
                    id="rad1"
                    className="modalradio"
                    value={"yes"}
                    onClick={props.handleUSDegreeFilter}
                  />
                  <label htmlFor="rad1" className="skill pl-4">
                    YES
                  </label>
                  <br />
                </div>
                <div className="d-flex mx-1">
                  <input
                    type="radio"
                    name="group"
                    id="rad2"
                    className="modalradio"
                    value={"no"}
                    onClick={props.handleUSDegreeFilter}
                  />
                  <label htmlFor="rad2" className="skill pl-4">
                    NO
                  </label>
                </div>
              </div>

              {/* us degree end */}
              {/* <hr className={"divider"} /> */}
              {/* security  */}
              <div className={"dropdownfilter"}>
                <h4 className="labelDesign">Security Clearence</h4>
                {securityCategory.map((data, index) => (
                  <li key={index} className="filterDirectorylisttitle">
                    {" "}
                    <input
                      type="checkbox"
                      id={data.name}
                      className="modalcheckbox ml-2"
                      value={data.name}
                      onClick={props.handleSecurityFilter}
                    />
                    <label htmlFor={data.name} className="pl-4 modaltext mt-1">
                      {data.name}
                    </label>
                  </li>
                ))}
              </div>
              {/*security end  */}
              {/* {certificate.length !== 0 && <hr className={"divider"} />} */}
              {/* certification */}
              <div className={"dropdownfilter"}>
                {certificate.length !== 0 && <h4 className="labelDesign">Certification</h4>}
                {certificate.slice(0, 5).map((certificate, index) => (
                  <div key={index}>
                    <li className="filterDirectorylisttitle">
                      <div className="row">
                        <div className="col-1">
                          <input
                            type="checkbox"
                            id={certificate.certificateName}
                            className="modalcheckbox ml-2"
                            value={certificate.certificateName}
                            onClick={props.handleCertificateFilter}
                          />
                        </div>
                        <div className={"col-9"}>
                          <label
                            htmlFor={certificate.certificateName}
                            className="pl-4 modaltext"
                          >
                            {certificate.certificateName}
                          </label>
                        </div>
                      </div>
                    </li>
                  </div>
                ))}
                {certificate.length > 5 && (
                  <button
                    type="button"
                    className="btnshow pl-5 colored-Royal-purple font-weight-500 font-size-08"
                    onClick={showCertificateModal}

                  >
                    Show more
                  </button>
                )}
                <div
                  className={`modal fade popupsecondbox newmodelbox experience-example-modal-lg ${certificateModal ? "show" : ""
                    }`}
                  aria-labelledby="myLargeModalLabel"
                  style={{
                    display: `${certificateModal ? "block" : "none"}`,
                  }}
                  tabIndex="-1"
                  role="dialog"
                  id={"modalLocation"}
                >
                  <div className="modal-dialog modal-lg modelposition">
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="input-group">
                          <div className="form-outline">
                            <input
                              type="search"
                              id="form1"
                              className="form-control"
                              placeholder="Search Location"
                            />
                          </div>
                        </div>
                        <button
                          type="button"
                          className="close"
                          onClick={hideCertificateModal}
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <ul className={"filterdirectory"}>
                          {certificate.slice(5).map((certificate, index) => (
                            <div key={index}>
                              <>
                                <li className="filterDirectorylisttitle">
                                  <div className="row">
                                    <div className="col-1">
                                      <input
                                        type="checkbox"
                                        id={certificate.certificateName}
                                        className="modalcheckbox ml-1"
                                        value={certificate.ertificateName}
                                        onClick={props.handleCertificateFilter}
                                      />
                                    </div>
                                    <div className={"col-11"}>
                                      <label
                                        htmlFor={certificate.certificateName}
                                        className="pl-1 modaltext"
                                      >
                                        {certificate.certificateName}
                                      </label>
                                    </div>
                                  </div>
                                </li>
                              </>
                            </div>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* certification end */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Filter);
